module.exports = __webpack_public_path__ + "static/media/BCD.a3884585.svg";